(function () {
  $(function() {
    $(".js-articleBody").find('a:not([data-ga-event-name])').attr({'data-ga-event-name': 'internal_link', 'data-ga-event-area': 'article_body'});
  });
})();